import { createAppKit } from '@reown/appkit/react'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { SolanaAdapter } from '@reown/appkit-adapter-solana/react'
import { mainnet, optimism, bsc, polygon, base, arbitrum, avalanche, solana } from '@reown/appkit/networks'
import { APP_ORIGIN, REOWN_PROJECT_ID } from '../config'

export const networks = [mainnet, optimism, bsc, polygon, base, arbitrum, avalanche, solana] as const
export const wagmiAdapter = new WagmiAdapter({ projectId: REOWN_PROJECT_ID, networks: networks as any, ssr: false })
export const solanaAdapter = new SolanaAdapter()

export const appKit = createAppKit({
  adapters: [wagmiAdapter, solanaAdapter],
  networks: networks as any,
  defaultNetwork: solana,
  projectId: REOWN_PROJECT_ID,
  metadata: {
    name: 'OnlyRose',
    description: 'OnlyRose NFT marketplace, creator platform and multichain trading',
    url: APP_ORIGIN,
    icons: [`${APP_ORIGIN}/api/v1/token/onlyrose/logo`]
  },
  features: {
    analytics: true,
    email: false,
    socials: []
  }
})
